const rangeRandom = (max, min) => Math.floor(Math.random() * (max - min + 1) + min);

export default rangeRandom;
